// extracted by mini-css-extract-plugin
export default {"actions-container":"styles_actions-container__efQYA","copy-button":"styles_copy-button__0yHiA"};